(function () {
  function isAniversarioActive() {
    return true;
  }

  var BURST_COLORS = ['#0a2a5e','#d4af37','#f0d78c','#1e63d0','#e8b923','#dc2626','#ffffff'];

  function showBurstIntro() {
    try { if (sessionStorage.getItem('pt_aniv_burst_seen')) return; } catch(_) {}
    try { sessionStorage.setItem('pt_aniv_burst_seen', '1'); } catch(_) {}

    var overlay = document.createElement('div');
    overlay.className = 'pt-aniv-burst';

    var flash = document.createElement('div');
    flash.className = 'pt-aniv-burst__flash';
    overlay.appendChild(flash);

    var streakWrap = document.createElement('div');
    streakWrap.className = 'pt-aniv-burst__streaks';
    var streakInner = document.createElement('div');
    streakInner.style.cssText = 'position:relative;width:0;height:0;';
    for (var s = 0; s < 14; s++) {
      var streak = document.createElement('span');
      streak.className = 'pt-aniv-burst__streak';
      streak.style.transform = 'rotate(' + (360 / 14 * s) + 'deg)';
      streak.style.animationDelay = (s * 0.02) + 's';
      streakInner.appendChild(streak);
    }
    streakWrap.appendChild(streakInner);
    overlay.appendChild(streakWrap);

    var pieceWrap = document.createElement('div');
    pieceWrap.className = 'pt-aniv-burst__pieces';
    for (var i = 0; i < 140; i++) {
      var angle = Math.random() * Math.PI * 2;
      var dist  = 220 + Math.random() * 520;
      var bx = Math.cos(angle) * dist;
      var by = Math.sin(angle) * dist;
      var br = Math.random() * 900 - 450;
      var size = 6 + Math.random() * 10;
      var shapeR = Math.random();
      var shape = shapeR > 0.66 ? 'circle' : shapeR > 0.5 ? 'rect' : 'strip';
      var piece = document.createElement('span');
      piece.className = 'pt-aniv-burst__piece';
      piece.style.width  = (shape === 'strip' ? size * 0.3 : size) + 'px';
      piece.style.height = (shape === 'rect' ? size * 0.5 : shape === 'strip' ? size * 2.4 : size) + 'px';
      piece.style.background = BURST_COLORS[i % BURST_COLORS.length];
      piece.style.borderRadius = shape === 'circle' ? '9999px' : '2px';
      piece.style.animationDelay = (Math.random() * 0.2) + 's';
      piece.style.setProperty('--bx', bx + 'px');
      piece.style.setProperty('--by', by + 'px');
      piece.style.setProperty('--br', br + 'deg');
      pieceWrap.appendChild(piece);
    }
    overlay.appendChild(pieceWrap);

    var text = document.createElement('div');
    text.className = 'pt-aniv-burst__text';
    text.innerHTML =
      '<span class="pt-aniv-burst__num">3°</span>' +
      '<span class="pt-aniv-burst__label">Aniversario</span>' +
      '<span class="pt-aniv-burst__brand">Crower</span>';
    overlay.appendChild(text);

    document.body.appendChild(overlay);
    setTimeout(function () { overlay.style.opacity = '0'; }, 2700);
    setTimeout(function () { if (overlay.parentNode) overlay.remove(); }, 3050);
  }

  var CONFETTI_COLORS = ['#0a2a5e','#d4af37','#f0d78c','#1e63d0','#e8b923','#dc2626','#ffffff'];
  var CONFETTI_COUNT = 55;
  var CONFETTI_BATCH_MS = 12000;
  var CONFETTI_ACTIVE_MS = 5 * 60 * 1000;
  var CONFETTI_PAUSE_MS = 10 * 1000;

  function spawnConfettiBatch() {
    var old = document.querySelector('.pt-aniv-confetti');
    if (old) old.remove();
    var wrap = document.createElement('div');
    wrap.className = 'pt-aniv-confetti';
    document.body.appendChild(wrap);
    for (var i = 0; i < CONFETTI_COUNT; i++) {
      var size = 6 + Math.random() * 8;
      var isCircle = Math.random() > 0.5;
      var p = document.createElement('div');
      p.className = 'pt-aniv-confetti-piece';
      p.style.left = (Math.random() * 100) + 'vw';
      p.style.width = size + 'px';
      p.style.height = (isCircle ? size : size * 0.5) + 'px';
      p.style.borderRadius = isCircle ? '9999px' : '2px';
      p.style.background = CONFETTI_COLORS[i % CONFETTI_COLORS.length];
      p.style.animationDelay = (Math.random() * 6) + 's';
      p.style.animationDuration = (5 + Math.random() * 6) + 's';
      p.style.setProperty('--pt-aniv-drift', (Math.random() * 80 - 40) + 'px');
      p.style.setProperty('--pt-aniv-rotate', (Math.random() * 720 - 360) + 'deg');
      wrap.appendChild(p);
    }
  }

  function injectConfetti() {
    var endTime = Date.now() + CONFETTI_ACTIVE_MS;
    function tick() {
      spawnConfettiBatch();
      if (Date.now() + CONFETTI_BATCH_MS < endTime) {
        setTimeout(tick, CONFETTI_BATCH_MS);
      } else {
        var remaining = endTime - Date.now();
        setTimeout(function () {
          var old = document.querySelector('.pt-aniv-confetti');
          if (old) old.remove();
          setTimeout(injectConfetti, CONFETTI_PAUSE_MS);
        }, Math.max(remaining, 0));
      }
    }
    tick();
  }

  var BALLOON_DATA = [
    { left: '4%',  top: '20%', color: '#d4af37', delay: 0 },
    { left: '88%', top: '30%', color: '#0a2a5e', delay: 1.5 },
    { left: '10%', top: '60%', color: '#e8b923', delay: 3 },
    { left: '92%', top: '70%', color: '#1e63d0', delay: 2 },
    { left: '50%', top: '10%', color: '#ff4444', delay: 0.8 },
  ];

  function injectBalloons() {
    if (document.querySelector('.pt-aniv-balloons')) return;
    var wrap = document.createElement('div');
    wrap.className = 'pt-aniv-balloons';
    document.body.appendChild(wrap);

    BALLOON_DATA.forEach(function (b) {
      var balloon = document.createElement('div');
      balloon.className = 'pt-aniv-balloon';
      balloon.style.left = b.left;
      balloon.style.top = b.top;
      balloon.style.animationDelay = b.delay + 's';
      balloon.style.transition = 'opacity 0.8s ease';

      var body = document.createElement('div');
      body.className = 'pt-aniv-balloon-body';
      body.style.background = b.color;

      var shine = document.createElement('span');
      shine.className = 'pt-aniv-balloon-shine';
      body.appendChild(shine);

      var string = document.createElement('div');
      string.className = 'pt-aniv-balloon-string';

      balloon.appendChild(body);
      balloon.appendChild(string);
      wrap.appendChild(balloon);
    });

    setTimeout(function () {
      wrap.style.transition = 'opacity 0.8s ease';
      wrap.style.opacity = '0';
      setTimeout(function () { if (wrap.parentNode) wrap.remove(); }, 900);
    }, 5000);
  }

  function showTopBanner() {
    var el = document.querySelector('.pt-aniv-top-banner');
    if (el) el.style.display = 'block';
    var orig = document.querySelector('.announcement-bar');
    if (orig) orig.style.display = 'none';
  }

  function styleAniversarioBtns() {
    document.querySelectorAll('.wholesale-btn, .fp-link, .product-row__link, .custom-uniform-banner .btn-primary, .db-cta, button[type="submit"]').forEach(function (btn) {
      if (!btn.closest('#SearchModal') && btn.id !== 'SearchPageSubmitBtn') {
        btn.classList.add('btn_aniversario_crower');
      }
    });
  }

  function watchAniversarioBtns() {
    var obs = new MutationObserver(styleAniversarioBtns);
    obs.observe(document.body, { childList: true, subtree: true });
  }

  function showCollectionBadges() {
    document.querySelectorAll('[data-aniv-product="true"] .pt-aniv-card-badge').forEach(function (el) {
      el.style.display = 'flex';
    });
  }

  function watchCollectionBadges() {
    var obs = new MutationObserver(showCollectionBadges);
    obs.observe(document.body, { childList: true, subtree: true });
  }

  function initAniversarioEffects() {
    if (!isAniversarioActive()) return;
    document.body.classList.add('aniv-active');
    showTopBanner();
    showBurstIntro();
    injectConfetti();
    styleAniversarioBtns();
    watchAniversarioBtns();
    injectBalloons();
    showCollectionBadges();
    watchCollectionBadges();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAniversarioEffects);
  } else {
    initAniversarioEffects();
  }

  window.CrowerAniversario = {
    isActive: isAniversarioActive
  };
})();
